import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoFastPFrameSkipInput.scss';
import ToggleButton from '../../ProducerComponents/ProducerControlPanel/Widgets/ToggleButton';
import useProject from '../../../hooks/useProject';

const VideoFastPFrameSkipInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();

  const onChange = (value: string | number | boolean) => {
    if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
      updateStream({
        transcoderVideoFastPFrameSkip: value,
      });
    } else {
      updateEncoder(project.encoder, {
        transcoderVideoFastPFrameSkip: value,
      });
    }
  };

  return (
    <div className="video-fast-p-frame-skip-input">
      <div className="input-title">{t('producer.inputs.video-fast-p-frame-skip.title')}</div>
      <ToggleButton
        leftText={t('producer.common.on')}
        leftValue={true}
        leftButtonClassName={`video-fast-p-frame-skip-button ${
          project.encoder?.transcoderVideoFastPFrameSkip === true
            ? 'control-panel-button-selected-button'
            : null
        }`}
        leftContentClassName="video-fast-p-frame-skip-text"
        rightText={t('producer.common.off')}
        rightValue={false}
        rightButtonClassName={`video-fast-p-frame-skip-button ${
          project.encoder?.transcoderVideoFastPFrameSkip === false
            ? 'control-panel-button-selected-button'
            : null
        }`}
        rightContentClassName="video-fast-p-frame-skip-text"
        footerText={t('producer.inputs.video-fast-p-frame-skip.footer')}
        isReadOnly={false}
        onSelection={onChange}
        leftAccessibilityName={t('producer.common.on')}
        rightAccessibilityName={t('producer.common.off')}
      />
    </div>
  );
};

export default React.memo(VideoFastPFrameSkipInput);
